import { BILLING_CYCLE, PlanModelInfo, planTypes } from '@/common/constants';
import { defaultMapper } from '@/common/service/default-mapper';

const ppmCategory = {
  zonemext: { typeNameKey: 'billing.zone_ppm.title', planNameKey: 'billing.zone_ppm.title' },
  zonemextp: { typeNameKey: 'billing.zone_ppm.title', planNameKey: 'billing.zone_ppm.title' },
};

export default (planMapJSON = {}) => {
  return Object.keys(ppmCategory).reduce((pre, key) => {
    return [
      ...pre,
      ...defaultMapper(planMapJSON[key], planTypes.ZONE_PPM).map(item => ({
        ...item,
        category: item.category.toLocaleLowerCase(),
        ...ppmCategory[key],
        billing_cycle: BILLING_CYCLE.ONE_TIME,
        supportCoupon: false,
        planModel: PlanModelInfo.usage
      })),
    ];
  }, []);
}
